import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';

interface ErrorCustomerOptionsProps {
  message: string;
  resetMessage: () => void;
}

const ErrorCustomerOptions = React.memo(({ message, resetMessage }: ErrorCustomerOptionsProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <div className="error-customers-options">
      <FontAwesomeIcon className="mr-1" icon={faSquareXmark} onClick={resetMessage} />
      <span className="error-message text-danger">{message.length > 0 ? message : 'failed loading customer options'}</span>
    </div>
  );
});

ErrorCustomerOptions.displayName = 'ErrorCustomerOptions';
export default ErrorCustomerOptions;
